<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-form-group label="Zone ID" :label-cols="2" :horizontal="true">
          <b-form-input
            type="text"
            v-model="identifier"
            placeholder="Enter Zone identifier"
            invalid-feedback="Required"
            :state="!$v.identifier.$invalid"
          />
        </b-form-group>
      </b-col>
      <b-col v-if="zones.length > 1" cols="1" class="pl-0">
        <b-button @click="removeZone" variant="danger" block>
          <i class="fa fa-trash" />
        </b-button>
      </b-col>
    </b-row>
    <template v-if="zone.samples && zone.samples.length">
      <b-row v-for="(sample, index) in zone.samples" :key="index">
        <b-col cols="2" class="text-right text-muted font-weight-bold">
          Sample {{ index + 1 }}
        </b-col>
        <b-col>
          <b-card no-body class="p-3">
            <project-soil-sample-form-group
              :submissionId="submissionId"
              :sampleId="sample.test_package_sample_id"
              :zone_id="zone_id"
              :addOns="addOns"
              :testPackage="testPackage"
              :allTestPackages="allTestPackages"
            />
          </b-card>
        </b-col>
      </b-row>
    </template>
    <hr />
  </div>
</template>

<script>
import ProjectSoilSampleFormGroup from "./ProjectSoilSampleFormGroup";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ProjectSoilZoneFormGroup",
  components: { ProjectSoilSampleFormGroup },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: null
    },
    zone_id: {
      type: String,
      default: null
    },
    addOns: {
      type: Array,
      default: () => []
    },
    testPackage: {
      type: Object,
      default: () => (null),
    },
    allTestPackages: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission"
    }),
    zones() {
      return this.submission(this.submissionId).zones;
    },
    zone() {
      return this.zones.find(item => item.zone_id === this.zone_id);
    },
    identifier: {
      get() {
        return this.zone.identifier;
      },
      set(value) {
        this.handleSubmissionUpdate({ value, field: "identifier" });
      }
    }
  },
  validations: {
    identifier: { required }
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    handleSubmissionUpdate({ value, field }) {
      this.zone[field] = value;
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: this.zones,
        name: "zones"
      });
    },
    removeZone() {
      this.$emit("updateSampleList", {
        action: "remove",
        zone_id: this.zone_id
      });
    }
  }
};
</script>
